import userLoggedIn from "./scripts/user-logged-in";
import Branding from './components/branding';
import maybeBlacklistedOverlay from './components/maybe-blacklisted-overlay';

class Products {
  constructor () {

    this.container = document.querySelector('.products');

    if(!this.container) {
      return;
    }

    userLoggedIn().then(token => {

      if(token === false) {
        window.location.href = window.site.home + '/logout';
        return;
      }

      if(maybeBlacklistedOverlay()) {
        return;
      }

      Branding.updateLogo();

      this.render();

    });

  }

  render() {
    if (!this.container) {
      return;
    }

    // Dates defined in ISO format with -07:00 offset to enforce America/Denver (MST) time
    const bfStart = new Date('2025-11-26T00:00:00-07:00');
    const cmStart = new Date('2025-11-30T00:00:00-07:00');

    // Memorial Day Weekend 2026 — Fri 5/22 through Thur 5/28 (-06:00 = MDT, Denver is on DST in May)
    const mdStart = new Date('2026-05-21T00:00:00-06:00');
    const mdEnd = new Date('2026-05-28T23:59:59-06:00');

    const end = new Date('2025-12-04T23:59:59-07:00');
    const now = new Date();

    let coupon = null;
    let useBfPricing = false;

    if (now >= bfStart && now < cmStart) {
      coupon = 'bfriday';
      useBfPricing = true;
    } else if (now >= cmStart && now <= end) {
      coupon = 'cmonday';
      useBfPricing = true;
    } else if (now >= mdStart && now <= mdEnd) {
      coupon = 'memday';
      useBfPricing = true;
    }

    const products = [
      {
        title: 'Temp Stick',
        subtitle: 'Temperature and Humidity',
        image_path: window.site.home + "/../assets/images/products/classic.png",
        regular_price: 159,
        sale_price: 149,
        bfriday_price: 129,
        target_url: 'https://tempstick.com/product/tempstick-wifi-temperature-humidity-sensor/'
      },
      {
        title: 'Temp Stick + Power',
        subtitle: 'With Power Outage Alerts',
        image_path: window.site.home + "/../assets/images/products/power.png",
        regular_price: 179,
        sale_price: 169,
        bfriday_price: 149,
        target_url: 'https://tempstick.com/product/temp-stick-power/'
      },
      {
        title: 'Temp Stick PRO',
        subtitle: 'With Temperature Probe',
        image_path: window.site.home + "/../assets/images/products/pro.png",
        regular_price: 209,
        sale_price: 199,
        bfriday_price: 179,
        target_url: 'https://tempstick.com/product/temp-stick-pro/'
      },
      {
        title: 'Temp Stick PRO',
        subtitle: 'With Buffer Bottle',
        image_path: window.site.home + "/../assets/images/products/buffer.png",
        regular_price: 209,
        sale_price: 199,
        bfriday_price: 179,
        target_url: 'https://tempstick.com/product/temp-stick-pro-with-buffer-bottle/'
      },
      {
        title: 'Temp Stick PRO',
        subtitle: 'With Pipe Temperature Clamp',
        image_path: window.site.home + "/../assets/images/products/pipes.png",
        regular_price: 209,
        sale_price: 199,
        bfriday_price: 179,
        target_url: 'https://tempstick.com/product/temp-stick-pro-for-frozen-pipe-prevention/'
      },
      {
        title: 'Temp Stick PRO',
        subtitle: 'With Wine Bottle Probe',
        image_path: window.site.home + "/../assets/images/products/wine.png",
        regular_price: 209,
        sale_price: 199,
        bfriday_price: 179,
        target_url: 'https://tempstick.com/product/temp-stick-pro-with-wine-bottle-probe/'
      },
      {
        title: 'Temp Stick',
        subtitle: 'With NIST Certification',
        image_path: window.site.home + "/../assets/images/products/nist.png",
        regular_price: null,
        sale_price: null,
        bfriday_price: null,
        target_url: 'https://tempstick.com/product-category/nist-temperature-sensors/'
      },
      {
        title: 'Temp Stick',
        subtitle: "Accessories and Probes",
        image_path: window.site.home + "/../assets/images/products/acc.png",
        regular_price: null,
        sale_price: null,
        bfriday_price: null,
        target_url: 'https://tempstick.com/product-category/accessories/'
      }
    ];

    const shopAllBaseUrl = 'https://tempstick.com/products/';

    function buildUrlWithCoupon(baseUrl) {
      if (!coupon) {
        return baseUrl;
      }

      if (baseUrl.indexOf('?') === -1) {
        return baseUrl + '?coupon=' + coupon;
      }

      return baseUrl + '&coupon=' + coupon;
    }

    function openWithAppSupport(url) {
      if (window.site && window.site.isApp && window.gonative && window.gonative.run && window.gonative.run.openExternalLink) {
        window.gonative.run.openExternalLink(url);
      } else {
        window.open(url, '_blank');
      }
    }

    function formatPrice(value) {
      if (value === null || value === undefined) {
        return '';
      }

      return '$' + value;
    }

    const existingList = this.container.querySelector('.products-list');

    if (existingList) {
      this.container.removeChild(existingList);
    }

    const list = document.createElement('div');
    list.className = 'products-list';

    products.forEach(product => {
      const productUrl = buildUrlWithCoupon(product.target_url);

      const item = document.createElement('div');
      item.className = 'products-list-item';

      const card = document.createElement('a');
      card.className = 'product-card';
      card.href = productUrl;

      card.addEventListener('click', function (event) {
        event.preventDefault();
        openWithAppSupport(productUrl);
      });

      const imageWrapper = document.createElement('div');
      imageWrapper.className = 'product-image';

      const img = document.createElement('img');
      img.src = product.image_path;
      img.alt = product.title;

      imageWrapper.appendChild(img);
      card.appendChild(imageWrapper);

      const body = document.createElement('div');
      body.className = 'product-body';

      const title = document.createElement('div');
      title.className = 'product-title';
      title.textContent = product.title;
      body.appendChild(title);

      if (product.subtitle) {
        const subtitle = document.createElement('div');
        subtitle.className = 'product-subtitle';
        subtitle.textContent = product.subtitle;
        body.appendChild(subtitle);
      }

      const effectiveSalePrice = useBfPricing && product.bfriday_price !== null && product.bfriday_price !== undefined
        ? product.bfriday_price
        : product.sale_price;

      if (product.regular_price && effectiveSalePrice) {
        const prices = document.createElement('div');
        prices.className = 'product-prices';

        const regular = document.createElement('span');
        regular.className = 'product-price-regular';
        regular.textContent = formatPrice(product.regular_price);
        prices.appendChild(regular);

        const sale = document.createElement('span');
        sale.className = 'product-price-sale';
        sale.textContent = formatPrice(effectiveSalePrice);
        prices.appendChild(sale);

        body.appendChild(prices);
      }

      card.appendChild(body);
      item.appendChild(card);
      list.appendChild(item);
    });

    const shopAllWrapper = document.createElement('div');
    shopAllWrapper.className = 'products-shop-all';

    const shopAllButton = document.createElement('button');
    shopAllButton.type = 'button';
    shopAllButton.className = 'shop-all-products';
    shopAllButton.textContent = 'Shop All Products';

    const shopAllUrl = buildUrlWithCoupon(shopAllBaseUrl);

    shopAllButton.addEventListener('click', function (event) {
      event.preventDefault();
      openWithAppSupport(shopAllUrl);
    });

    shopAllWrapper.appendChild(shopAllButton);
    list.appendChild(shopAllWrapper);

    this.container.appendChild(list);
  }

}

new Products();
